import React from "react";
import NewHeader from "./header/new-index";
import Footer from "./footer/index";

const Layout = ({ children }) => {
    return (
        <main>
            <NewHeader />
            <div className="main">{children}</div>
            <Footer />
        </main>
    );
};

export default Layout;